// Only a random test nonce is sent. The receiving extension also verifies its
// local test, current receiver and answered SIP session before confirming success.
export function onboardingTestMetadata(search: string): { onboardingTestId?: string } {
  const id = new URLSearchParams(search).get('bcallTest');
  return id && /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(id)
    ? { onboardingTestId: id } : {};
}
